import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { MorphIcon } from 'react-svg-buttons/lib';
import menuBorder from 'assets/icons/menu_border.svg';
import CurrentCycleLeft from 'assets/icons/current_cycle_left.svg';
import CurrentCycleRight from 'assets/icons/current_cycle_right.svg';
import { menuItems, secondaryItems } from './menuItems';
import './styles.css';

const renderMenuItem = (item, open, history) => {
  return (
    <div key={item.id} className="menu__item">
      <div className="menu__icon__container">
        <img
          className="menu__icon"
          src={item.icon}
          alt={item.label}
          onClick={() => { history.push(item.to) }}
        />
      </div>
      {open && <Link to={item.to} className="menu__item__label navigation">{item.label}</Link>}
    </div>
  );
}

const renderSecondaryItem = (item, open, logout) => {
  return (
    <div key={item.id} className="menu__secondary__item">
      <Link to={item.to} onClick={item.id === "logout" ? logout : null} className="menu__secondary__label link">{item.label}</Link>
    </div>
  );
}

const User = ({ name }) => {
  return (
    <Link to="/" className="menu__user__name__container">
      <div className="menu__user__name">
        <img className="menu__user__border" src={CurrentCycleLeft} alt="" />
        <div className="h2">{name}</div>
        <img className="menu__user__border" src={CurrentCycleRight} alt="" />
      </div>
    </Link>
  );
}

export default class Navigation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
  }

  toggleMenu = () => this.setState({ open: !this.state.open })

  render() {
    const { open } = this.state;
    let logout = this.props.logout.bind(this);

    return (
      <div className={`menu ${open ? 'menu--open' : ''}`}>
        <div className="menu__contents">
          <div className={'menu__open__icon'}>
            <img src={menuBorder} className="menu__open__border" alt="" />
            <MorphIcon type={open ? 'cross' : 'bars'} thickness={2} color={'#343754'} onClick={this.toggleMenu} />
          </div>
          <div className="menu__inner">
            <div className="menu__user">
              <User name={'Joanne'} />
              <div className="link">{'Edit Account'}</div>
            </div>
            <div className="menu__options">
              {menuItems.map((item) => renderMenuItem(item, open, this.props.history))}
              <div className="menu__secondary">
                {secondaryItems.map((item) => renderSecondaryItem(item, open, logout))}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
};



// WEBPACK FOOTER //
// ./src/components/Navigation/Navigation.js